import React, { useState } from 'react';

const PageContext = React.createContext({
  currentPage: 'Orders',
  onSetOrders: () => {},
  onSetProfile: () => {},
  onSetCalendar: () => {},
  onSetInbox: () => {},
  onSetTrash: () => {},
  onReset: () => {},
  onLoading: () => {}
 });

export const PageContextProvider = (props) => {
  // TODO - This may not be the standard Reactish way to handle this but I truly enjoyed figuring this out!
  const [currentPage, setCurrentPage] = useState('Loading');

  const setOrders = async () => {
    setCurrentPage('Orders');
    localStorage.setItem('lastPage', 'Orders');
  };

  const setProfile = async () => {
    setCurrentPage('Profile');
    localStorage.setItem('lastPage', 'Profile');
  };
  
  const setCalendar = async () => {
    setCurrentPage('Calendar');
    localStorage.setItem('lastPage', 'Calendar');
  };
  
  const setInbox = async () => {
    setCurrentPage('Inbox');
    localStorage.setItem('lastPage', 'Inbox');
  };
  
  const setTrash = async () => {
    setCurrentPage('Trash');
    localStorage.setItem('lastPage', 'Trash');
  };

  const setReset = async () => {
    setTimeout(() => {
      setCurrentPage('Orders');
      localStorage.setItem('lastPage', 'Orders');
    }, 300);
  };

  const setLoading = () => {
    setCurrentPage('Loading');
  };

  const setStoragedPage = () => {
    setCurrentPage(localStorage.getItem('lastPage'));
  };

  return (
    <PageContext.Provider
      value={{
        currentPage: currentPage,
        onSetOrders: setOrders,
        onSetProfile: setProfile,
        onSetCalendar: setCalendar,
        onSetInbox: setInbox,
        onSetTrash: setTrash,
        onReset: setReset,
        onLoading: setLoading,
        onReload: setStoragedPage
      }}
    >
      {props.children}
    </PageContext.Provider>
  );
};

export default PageContext;
